// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '6701bfdb2d96303cdf51c8b0ac1fff0bdcc7f938';
export const BUILD_NUMBER = '206';
export const BUILD_TIMESTAMP = '2026-07-23T04:26:11.416Z';
